const { getOffsetTop } = window.BAO.Utils

class TextImageReveal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    if (!window.BAO.MediaBreakpoints.isSm) return

    window.setTimeout(() => {
      this.setupWords()

      this.updateEl()
    }, 500)

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.cachedWordEls = null
    this.cachedMediaEls = null
    this.cachedScrollPositions = null
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.debouncedOnResize = window.BAO.Utils.debounce(() => {
      this.cachedScrollPositions = null
    }, 200)

    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.debouncedOnResize)
  }

  setupWords () {
    let buildContent = ''

    this.els.message.elements.forEach((messageEl) => {
      const wordsArray = messageEl.innerText.split(' ')

      wordsArray.forEach((word) => {
        buildContent += `<span class="sec-TextImageReveal_Word" data-text-image-reveal-el="word" data-index="${messageEl.dataset.index}">${word}</span> `
      })
    })

    this.els.overlay.element.innerHTML = buildContent

    this.cachedWordEls = null
    this.cachedScrollPositions = null
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.revealText()
  }

  revealText () {
    if (!this.cachedScrollPositions) {
      const containerOffsetTop = getOffsetTop(this)
      this.cachedScrollPositions = {
        start: containerOffsetTop,
        end: containerOffsetTop + window.innerHeight - 200,
      }
    }
    const elementStartPoint = this.cachedScrollPositions.start
    const elementEndPoint = this.cachedScrollPositions.end

    if (!this.cachedWordEls) {
      this.cachedWordEls = this.querySelectorAll(
        '[data-text-image-reveal-el="word"]',
      )
    }
    if (!this.cachedMediaEls) {
      this.cachedMediaEls = this.querySelectorAll(
        '[data-text-image-reveal-el="media"]',
      )
    }
    const wordEls = this.cachedWordEls
    const mediaEls = this.cachedMediaEls

    if (this.lastKnownY <= elementStartPoint) {
      wordEls.forEach((wordEl) => {
        wordEl.style.setProperty('--Reveal_Amount', '0%')
      })

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      wordEls.forEach((wordEl) => {
        wordEl.style.setProperty('--Reveal_Amount', '100%')
      })

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    wordEls.forEach((wordEl, index) => {
      const minimumPercent = index / wordEls.length
      const maximumPercent = (index + 1) / wordEls.length
      const isWithinRange =
        scrollYAsAPercentageOfJourney >= minimumPercent &&
        scrollYAsAPercentageOfJourney < maximumPercent

      if (isWithinRange) {
        const wordScrolledAmount =
          scrollYAsAPercentageOfJourney - minimumPercent
        const wordMaxAmount = maximumPercent - minimumPercent

        const wordProgress = wordScrolledAmount / wordMaxAmount

        const wordProgressAmount = Math.round(wordProgress * 100 * 10) / 10

        const activeMediaIndex = wordEl.dataset.index

        if (activeMediaIndex !== '0') {
          mediaEls.forEach((mediaEl) => {
            mediaEl.setAttribute(
              'aria-hidden',
              mediaEl.dataset.index !== activeMediaIndex,
            )
          })
        }

        wordEl.style.setProperty('--Reveal_Amount', `${wordProgressAmount}%`)
      } else if (scrollYAsAPercentageOfJourney > maximumPercent) {
        wordEl.style.setProperty('--Reveal_Amount', '100%')
      } else {
        wordEl.style.setProperty('--Reveal_Amount', '0%')
      }
    })
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.debouncedOnResize)

    this.cachedWordEls = null
    this.cachedMediaEls = null
    this.cachedScrollPositions = null
  }
}

if (!customElements.get('text-image-reveal')) {
  customElements.define('text-image-reveal', TextImageReveal)
}
